/**
 * @desc getCabinFactoryDirectLockQuantity
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<any>>;
export function request(
  body: Array<defs.tms.CabinSkuDetailDataResponseDtoReq>,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinFactoryDirectLockQuantity`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
